import { Inline, Text } from '@etg/wings';
import type { CabinBaggageTripSummary } from '@eti/schema-types';
import { useTranslation } from '@eti/providers';
import { XCircle } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import isCabinBaggageNotIncluded from './utils/isCabinBaggageNotIncluded';
import { iconStyles } from './CabinBaggageFeature';

const featureTextStyles = css`
  color: #737373;
  width: -webkit-fill-available; /* stylelint-disable */
`;

interface CabinBaggageNotIncludedFeatureProps {
  cabinBaggageTripSummary: CabinBaggageTripSummary;
  showNotIncludedProducts: Boolean;
}

const CabinBaggageNotIncludedFeature = ({
  cabinBaggageTripSummary,
  showNotIncludedProducts,
}: CabinBaggageNotIncludedFeatureProps) => {
  const { t } = useTranslation();
  if (!isCabinBaggageNotIncluded(cabinBaggageTripSummary, showNotIncludedProducts)) {
    return null;
  }

  const cabinBaggageName = t('BrandedFares.CabinBaggageNotIncluded.Text', 1);
  return (
    <Inline as="li" noWrap role="listitem" spacing={8}>
      <XCircle className={iconStyles} color="#737373" size={20} weight="thin" />
      <Text as="p" className={featureTextStyles}>
        {cabinBaggageName}
      </Text>
    </Inline>
  );
};

export default CabinBaggageNotIncludedFeature;
